<template>
  <v-infinite-scroll
      direction="horizontal"
      @load="$emit('loadCarAds', $event)"
  >
    <template v-slot:error>
      <p :class="cars.length !== 0  ? 'message-label' : 'empty-message-label'">
        {{ messages.en.car_view.cars_ads_loading_error }}
      </p>
    </template>
    <template v-slot:empty>
      <p :class="cars.length !== 0  ? 'message-label' : 'empty-message-label'">
        {{ messages.en.car_view.cars_ads_empty }}
      </p>
    </template>
    <template
        v-for="(item, index) in cars"
        :key="item"
    >
      <car-ad-list-item
          :id="item.id"
          :title="item.title"
          :subtitle="item.subtitle"
          :index="index"
          :main-photo="item.mainPhoto"
          :first-price="item.prices.filter((currency) => currency.currency === Currency.KRW)[0].value + ' ₩'"
          :second-price="item.prices.filter((currency) => currency.currency === Currency.USD)[0].value + ' $'"
          :third-price="item.prices.filter((currency) => currency.currency === Currency.EUR)[0].value + ' €'"
      />
    </template>
  </v-infinite-scroll>
</template>

<script>
import CarAdListItem from "@/components/Car/CarAdListItem.vue";
import {Currency} from "@/common/enum/currency";
import {messages} from "@/common/enum/messages";

export default {
  name: "CarAdList",
  emits: ['loadCarAds'],
  computed: {
    messages() {
      return messages
    },
    Currency() {
      return Currency
    }
  },
  components: {CarAdListItem},
  props: {
    cars: Array,
    onLoad: Function
  }
}
</script>

<style scoped>
.message-label {
  width: 15rem;
}
.empty-message-label {
  text-wrap: none;
}
</style>